import { useRef, createRef } from "react";
import InputCheckbox from "../formcontrols/InputCheckbox";
import { startCase, random } from "lodash";

export default function EnumCheckBox<T extends Record<string, string>>(props: {
  enum: T;
  onChange: (selectedEnumKeys: Array<keyof T>) => void;
  state: Array<keyof T>;
  disabled?: boolean;
}) {
  // reffys
  const checkboxRefs = useRef(
    [...Array(Object.keys(props.enum).length)].map(() =>
      createRef<HTMLInputElement>(),
    ),
  );

  function onChangeHandler() {
    const refValues = checkboxRefs.current.flatMap((r) => {
      if (r.current) {
        if (r.current.checked) {
          return r.current?.id;
        } else {
          return [];
        }
      } else {
        return [];
      }
    });

    // remove id's from keys
    const enumKeys = refValues.map((value) =>
      value.substring(0, value.indexOf("__")),
    );

    props.onChange(enumKeys);
  }

  return (
    <>
      {Object.entries(props.enum).map(([key, value], index) => {
        // for human purposes
        let displayName = startCase(
          value.replaceAll("_", " ").toLocaleLowerCase(),
        );

        // æ, ø og å'ify the enum
        displayName = displayName
          .replaceAll("ae", "æ")
          .replaceAll("oe", "ø")
          .replaceAll("aa", "å");

        const id = `${key}__${random(0, 1000)}`;

        return (
          <InputCheckbox
            id={id}
            key={id}
            label={displayName}
            ref={checkboxRefs.current[index]}
            defaultChecked={props.state?.includes(key)}
            disabled={props.disabled}
            onChange={() => onChangeHandler()}
          />
        );
      })}
    </>
  );
}
